import {observer} from 'mobx-react-lite';
import styled from '@emotion/styled';
import React, {useState} from 'react';
import {DnDAreaState} from './DnDArea.state';
import { mainColors } from 'src/assets/colors';

interface PropsType {
    label: string,
    onDrop: (files: File[]) => Promise<void>,
    allowedMimeTypes: string[]
}

export const DnDArea = observer((props: PropsType) => {
    const {onDrop, label, allowedMimeTypes} = props;

    const [ state ] = useState(() => new DnDAreaState(onDrop, allowedMimeTypes));

    return (<Wrapper
        isHighlighted={ state.isFileOver }
        onDragEnter={ state.highlightArea }
        onDragOver={ state.highlightArea }
        onDragLeave={ state.restoreArea }
        onDrop={ state.handleDrop }>
        <Label>{label}</Label>
    </Wrapper>);
});

interface WrapperPropsType {
    isHighlighted: boolean
}

const Wrapper = styled('div', { label: 'Wrapper' })<WrapperPropsType>`
    border-radius: 4px;
    border: dashed 2px ${mainColors.main.secondary};
    background-color: ${({ isHighlighted }) => isHighlighted ? mainColors.grays.gray300 : mainColors.grays.gray200};
`;

const Label = styled('span', { label: 'Label' })`
    padding: 36px 22px;
    display: block;
    font-size: 14px;
    color: ${mainColors.main.primary};
    user-select: none;
`;
